var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDevice = function SvgDevice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2.4h8A1.6 1.6 0 0 1 17.6 4v16a1.6 1.6 0 0 1-1.6 1.6H8A1.6 1.6 0 0 1 6.4 20V4A1.6 1.6 0 0 1 8 2.4ZM5 4a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v16a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3V4Zm10 2a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
    fill: "#000"
  })));
};
export default SvgDevice;